import React, { HTMLAttributes } from 'react';
export interface Props extends HTMLAttributes<HTMLDivElement> {
  children?: JSX.Element | JSX.Element[];
}

export const Row = ({ children, className }: Props) => {
  return <div className={`row ${className}`}>{children}</div>;
};
